import styled, { css } from 'styled-components'
import { tokens } from '@arvoreeducacao/bonsai-ds'

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  min-height: 100vh;
  max-height: 100vh;
  padding: 5% 0;
  overflow-y: auto;
  z-index: 1001;
  display: flex;
  justify-content: center;

  ${props => `
      ${
        props.fullScreen
          ? `
      @media (max-width: ${tokens.breakpoints.tablet}px) {
        padding: 0;
        > div {
          min-height: 100%;
          position: fixed;
          top: 0;
          left: 0;
        }
      }
      `
          : ''
      }
    `};
`

export const StyledModal = styled.div`
  ${({ width }) => css`
    background-color: ${tokens.colors.white};
    border-radius: ${tokens.radius.xlarge};
    outline: none;
    z-index: 1002;
    pointer-events: all;
    height: 100%;
    position: relative;
    width: 90%;

    @media (min-width: ${tokens.breakpoints.desktop}px) {
      width: auto;
    }

    ${width && `width: ${width};`};
  `};
`
